import React from 'react';
import styled from 'styled-components';

import CoreInput, { InputElement, StyledNumberFormat, StyledDateFormat } from '../../../_common/CoreInput/CoreInput';
import Affix from '../../../_common/Affix/Affix';
import Aura from '../../../_common/Aura/Aura';
import Outline from '../../../_common/Outline/Outline';
import AffixBackground from '../../../_common/Affix/AffixBackground';

import { NewInputProps } from '../../NewInput';

const StyledInput = styled(CoreInput)`
  height: 40px; /* Prevents changing the cell original size */
  z-index: 1; /* Places it above Aura so content is selectable */

  ${InputElement},
  ${StyledNumberFormat},
  ${StyledDateFormat} {
    height: 40px; /* Prevents changing the cell original size */

    &,
    &:hover,
    &:focus-visible {
      background: none;
      border: none;
      box-shadow: none;

      // Overrides padding inherited from CoreInput, because TableInput uses
      // outlines instead of borders. Padding needs to be 1px larger here to
      // compensate for the missing border.
      padding-bottom: 10px;
      padding-left: 10px;
      padding-top: 10px;
    }
  }

  ${Affix} {
    background: none;
    border: none;
    border-radius: 0;
    height: 40px;
  }
`;

function TableInput(props: NewInputProps) {
  const { className, style, ...otherProps } = props;
  const { prefix, suffix } = props;
  return (
    <>
      {prefix && typeof prefix !== 'function' && <AffixBackground theme={{ seam: 'right' }}>{prefix}</AffixBackground>}
      <StyledInput {...otherProps} width="full" />
      {suffix && typeof suffix !== 'function' && <AffixBackground theme={{ seam: 'left' }}>{suffix}</AffixBackground>}
      <Aura theme={{ disabled: props.disabled }} htmlFor={props.id} />
      <Outline
        theme={{ invalid: props.invalid, disabled: props.disabled, triangle: true }}
        inputComponent={StyledInput}
      />
    </>
  );
}

TableInput.defaultProps = {
  value: undefined,
  onChange: undefined,
  width: 'large',
  align: 'left',
  prefix: undefined,
  suffix: undefined,
  invalid: false,
  disabled: false,
  inline: false,
  mask: undefined,
};

export default TableInput;
